import { useCanvasStore } from '@/components/canvas/store/canvas.store';
import { scheduleFitCurrentWorkspacePage } from '@/components/canvas/workspace/controllers/layoutModeSwitch';

export type WorkspacePageNavDirection = 'prev' | 'next';

export function canNavigateWorkspacePage(
  direction: WorkspacePageNavDirection,
  pageIndex1Based: number,
  pageCount: number,
): boolean {
  if (pageCount <= 1) return false;
  const idx = pageIndex1Based - 1;
  if (direction === 'prev') return idx > 0;
  return idx < pageCount - 1;
}

/** 按文档顺序切换上一页/下一页，并适应当前页视口 */
export function navigateWorkspacePage(
  direction: WorkspacePageNavDirection,
  anchorPageId?: string,
): void {
  const st = useCanvasStore.getState();
  const anchorId = anchorPageId ?? st.currentPageId;
  if (!anchorId) return;

  const idx = st.pages.findIndex((p) => p.id === anchorId);
  if (idx < 0) return;

  const nextIdx = direction === 'prev' ? idx - 1 : idx + 1;
  if (nextIdx < 0 || nextIdx >= st.pages.length) return;

  const targetId = st.pages[nextIdx]!.id;
  if (st.workspacePageLayoutMode === 'single') {
    st.bringPageToFront(targetId);
  }
  st.setCurrentPageId(targetId);

  const layoutMode = st.workspacePageLayoutMode;
  const animated = layoutMode === 'horizontal' || layoutMode === 'vertical';
  scheduleFitCurrentWorkspacePage({ animated });
}
